const locationsReducer = (
  state = {
    data: null,
    graphSummaryData: {},
    loading: false,
    workforceLoading: false,
    zones: null,
    wards: null
  },
  action
) => {
  switch (action.type) {
    case "SET_LOCATIONS_LOADING":
      return { ...state, loading: action.payload.loading };

    case "SET_WORKFORCE_LOADING":
      return { ...state, workforceLoading: action.payload.loading };

    case "PUT_LOCATIONS_DATA":
      return { ...state, data: action.payload.data };

    case "PUT_ZONE_AND_WARD":
      return {
        ...state,
        wards: action.payload.data.wards,
        zones: action.payload.data.zones
      };

    case "SET_GRAPH_SUMMARY_DATA":
      return {
        ...state,
        graphSummaryData: { ...state.graphSummaryData, ...action.payload }
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};

export default locationsReducer;
